import store from "@/state/store";

export default [
  // FieldMR Dashboard
  // {
  //   path: "/fieldmr/dashboard",
  //   name: "Dashboard",
  //   meta: {
  //     authRequired: false,
  //   },
  //   component: () => import("../views/pages/fieldMrDashboard/index.vue"),
  // },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          if (
            this.$store.state.authfack.user.roles.filter(
              (f) => f.name != "SuperAdmin"
            ).length > 0 &&
            this.$store.state.authfack.user.permissions
              .map((p) => p.name)
              .includes("GravyOrder")
          ) {
            next({ name: "Gravy Orders" });
          } else if (
            this.$store.state.authfack.user.roles.filter(
              (f) => f.name != "SuperAdmin"
            ).length > 0 &&
            this.$store.state.authfack.user.permissions
              .map((p) => p.name)
              .includes("RestaurantPartner")
          ) {
            next({ name: "Restaurants" });
          } else if (
            this.$store.state.authfack.user.roles.filter(
              (f) => f.name != "SuperAdmin"
            ).length > 0 &&
            this.$store.state.authfack.user.permissions
              .map((p) => p.name)
              .includes("Analytics")
          ) {
            next({ name: "home" });
          } else {
            next({ name: "home" });
          }
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  // {
  //   path: "/register",
  //   name: "register",
  //   component: () => import("../views/pages/account/register"),
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters["auth/loggedIn"]) {
  //         // Redirect to the home page instead
  //         next({ name: "home" });
  //       } else {
  //         // Continue to the login page
  //         next();
  //       }
  //     },
  //   },
  // },
  {
    path: "/forgot-password",
    name: "Forgot-password",
    component: () => import("../views/pages/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // Remove user and token from localStorage
        localStorage.removeItem("user");
        localStorage.removeItem("token");

        // Check if the previous route required authentication
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        );

        // Use `next()` to either redirect to login or continue to the next route
        if (authRequiredOnPreviousRoute) {
          next({ name: "login" }); // Redirect to login if the previous route required authentication
        } else {
          next({ name: "home" }); // Navigate to home as fallback
        }
      },
    },
  },
  {
    path: "/",
    name: "home",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/dashboard/index"),
  },
  {
    path: "/categories",
    name: "Categories",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Categories/index"),
  },
  {
    path: "/tickets_dashboard",
    name: "Tickets Dashboard",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Tickets/Dashboard/index"),
  },
  {
    path: "/raise_ticket",
    name: "Raise Tickets",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/Tickets/RaiseTicket/index"),
  },
  {
    path: "/brands",
    name: "Brands",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Brands/index"),
  },
  {
    path: "/restaurants",
    name: "Restaurants",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Restaurants/index"),
  },
  {
    path: "/stores",
    name: "Store",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Restaurants/Stores/list"),
  },
  // {
  //   path: "/rp_pnl",
  //   name: "RP PnL",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("../views/pages/Dilfoods/Restaurants/RP_PnL/index"),
  // },
  {
    path: "/modifier_groups",
    name: "Modifier Groups",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/options_groups/index.vue"),
  },
  {
    path: "/modifiers",
    name: "Modifier",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/options_groups/options/index.vue"),
  },
  {
    path: "/charges",
    name: "Charges",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/charges/index.vue"),
  },
  {
    path: "/items",
    name: "Items",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/items/index.vue"),
  },
  {
    path: "/menu",
    name: "Menu",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/menu/index.vue"),
  },
  {
    path: "/gravies",
    name: "Gravy",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Gravy/index.vue"),
  },
  {
    path: "/horeca_management",
    name: "Horeca Management",
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/pages/Dilfoods/HorecaManagement/index.vue"),
  },
  {
    path: "/packagings",
    name: "Packaging",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Packaging/index.vue"),
  },
  {
    path: "/gravy_orders",
    name: "Gravy Orders",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Gravy/Orders/index.vue"),
  },
  {
    path: "/gravy_orders_returns",
    name: "Gravy Orders Returns",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/Gravy/Orders/Returns/index.vue"),
  },
  {
    path: "/orders",
    name: "Orders",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Orders/index.vue"),
  },
  {
    path: "/gravy_transfer_request",
    name: "Gravy Transfer Request",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/ProductionBatches/addGravyTransfer.vue"
      ),
  },
  {
    path: "/packaging_transfer_request",
    name: "Packaging Transfer Request",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/ProductionBatches/addPackagingTransfer.vue"
      ),
  },
  {
    path: "/payout_policy",
    name: "Payout Policy",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/payouts/index.vue"),
  },
  {
    path: "/business_report",
    name: "Business Report",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/BusinessReport/index.vue"),
  },
  {
    path: "/ads_burn",
    name: "Ads Burn",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/AdsBurn/index.vue"),
  },
  // {
  //   path: "/route_plan",
  //   name: "Route Plan",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/RoutePlan/index.vue"),
  // },
  {
    path: "/production_projection",
    name: "Production Projection",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Analytics/production_projection/index.vue"
      ),
  },
  // {
  //   path: "/gravy_projection",
  //   name: "Gravy Projection",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/gravy_projection/index.vue"),
  // },
  // {
  //   path: "/packaging_projection",
  //   name: "Packaging Projection",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import(
  //       "../views/pages/Dilfoods/Analytics/packaging_projection/index.vue"
  //     ),
  // },
  // {
  //   path: "/projection_data",
  //   name: "Projection Data",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/projection_data/index.vue"),
  // },
  {
    path: "/transfer_projection",
    name: "Transfer Projection",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/Analytics/transfer_projection/index.vue"),
  },
  // {
  //   path: "/warehouse_projection",
  //   name: "Warehouse Projection",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import(
  //       "../views/pages/Dilfoods/Analytics/warehouse_projection/index.vue"
  //     ),
  // },
  // {
  //   path: "/catalogue_analytics",
  //   name: "Catalogue Analytics",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/catalogue/catalogue.vue"),
  // },
  {
    path: "/sales_analytics",
    name: "Sales Analytics",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/Analytics/Sales/index.vue"),
  },
  {
    path: "/gravy_consumption",
    name: "Gravy Consumption Analytics",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Analytics/gravy_consumption_analytics/index.vue"
      ),
  },
  {
    path: "/packaging_consumption",
    name: "Packaging Consumption Analytics",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Analytics/packaging_consumption_analytics/index.vue"
      ),
  },
  // {
  //   path: "/outlet_performance",
  //   name: "Outlet Analytics",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/Outlet/index.vue"),
  // },
  {
    path: "/funnel_analytics",
    name: "Funnel Analytics",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/Analytics/Funnel/index.vue"),
  },
  // {
  //   path: "/rhi_analytics",
  //   name: "Rhi Analytics",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("../views/pages/Dilfoods/Analytics/Rhi/index.vue"),
  // },
  // {
  //   path: "/stock_out_analytics",
  //   name: "StockOut Analytics",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/StockoutAnalytics/index.vue"),
  // },
  // {
  //   path: "/complaints_analytics",
  //   name: "Complaints Analytics",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/Complaints/index.vue"),
  // },
  {
    path: "/restaurant_analytics",
    name: "Restaurant Analytics",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/Analytics/Restaurant/index.vue"),
  },
  {
    path: "/restaurant_payout_analytics",
    name: "Restaurant Payout Analytics",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/Analytics/Restaurant/payout.vue"),
  },
  // {
  //   path: "/outlet_map_view",
  //   name: "Outlet Map View",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/Outlet/geo_view.vue"),
  // },
  {
    path: "/funnel_import",
    name: "Funnel Data",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Funnel/index.vue"),
  },
  {
    path: "/order_ratings_import",
    name: "Order Ratings Import",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/OrderRatings/index.vue"),
  },
  {
    path: "/rhi_import",
    name: "Rhi Data",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Rhi/index.vue"),
  },
  {
    path: "/complaints_import",
    name: "Complaints Data",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Complaints/index.vue"),
  },
  {
    path: "/dil_leads",
    name: "Dil Leads",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/DilLeads/index.vue"),
  },
  // {
  //   path: "/stock_inspection",
  //   name: "Stock Inspection",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Gravy/Orders/PhysicalStock/index.vue"),
  // },
  {
    path: "/warehouses",
    name: "Warehouses",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Warehouse/index.vue"),
  },
  {
    path: "/gravy_production_batches",
    name: "Gravy Production Batches",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/ProductionBatches/Gravy/index.vue"
      ),
  },
  {
    path: "/packaging_production_batches",
    name: "Packaging Production Batches",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/ProductionBatches/Packaging/index.vue"
      ),
  },
  {
    path: "/gravy_transfer_batches",
    name: "Gravy Transfer Batches",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/ProductionBatches/Transfer/GravyIndex.vue"
      ),
  },
  {
    path: "/packaging_transfer_batches",
    name: "Packaging Transfer Batches",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/ProductionBatches/Transfer/index.vue"
      ),
  },
  {
    path: "/stock_details",
    name: "Production Stock Details",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/ProductionBatches/Stock/index.vue"
      ),
  },
  {
    path: "/warehouse_stock_inspection",
    name: "Warehouse Stock Inspection",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/ProductionBatches/Warehouse_Stock_Inspection/index.vue"
      ),
  },
  // {
  //   path: "/stock_inspection_data",
  //   name: "Stock Inspection List",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import(
  //       "../views/pages/Dilfoods/Gravy/Orders/PhysicalStock/list/index.vue"
  //     ),
  // },
  {
    path: "/daily_hygiene_checklist",
    name: "Daily Hygiene Checklist",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/HygieneChecklist/index.vue"),
  },
  // {
  //   path: "/staff_incentives",
  //   name: "Staff Incentives",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Incentives/Staff_Incentives/index.vue"),
  // },
  {
    path: "/raw_materials",
    name: "Raw Materials",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/RawMaterials/index.vue"),
  },
  {
    path: "/raw_material_orders",
    name: "Raw Material Orders",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/RawMaterials/orders.vue"),
  },
  // {
  //   path: "/item_ratings_analytics",
  //   name: "Item Rating Dashboard",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/ItemRatings/index.vue"),
  // },
  // {
  //   path: "/city_consumption",
  //   name: "City Consumption",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/CityConsumption/index.vue"),
  // },
  {
    path: "/raw_material_to_gravy_recipe",
    name: "R-G Recipe",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/RecipeManagement/RG/index.vue"),
  },
  {
    path: "/add_raw_material_to_gravy_recipe/:recipe_id?/:version?",
    name: "Add R-G Recipe",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/RecipeManagement/RG/add.vue"),
  },
  {
    path: "/raw_material_to_gravy_recipe_card",
    name: "R-G Recipe Card",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/RecipeManagement/RecipeCard/index.vue"),
  },
  {
    path: "/add_raw_material_to_gravy_recipe_card/:recipe_card_id?",
    name: "R-G Recipe Card Add",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/RecipeManagement/RecipeCard/add.vue"),
  },
  // {
  //   path: "/warehouse_stock_analytics",
  //   name: "Warehouse Stock Analytics",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/WarehouseStock/index.vue"),
  // },
  // {
  //   path: "/gravy_varience_analytics",
  //   name: "Gravy Varience Analytics",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Analytics/GravyVarience/index.vue"),
  // },
  {
    path: "/new_launches_revenue_contribution",
    name: "New Launch Revenue Analytics",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/Analytics/New_Launches/index.vue"),
  },
  {
    path: "/vendors",
    name: "Vendors",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/Vendors/index.vue"),
  },
  // {
  //   path: "/route-plan",
  //   name: "Route Plan",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("../views/pages/Dilfoods/Vendors/route-plan.vue"),
  // },
  // {
  //   path: "/gravy_packaging_warehouse",
  //   name: "Gravy Packaging Warehouse",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import(
  //       "../views/pages/Dilfoods/Analytics/GravyPackagingWarehouse/index.vue"
  //     ),
  // },
  {
    path: "/users",
    name: "User List",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/Dilfoods/User_Management/Users/index.vue"),
  },
  // {
  //   path: "/category_level_assignee",
  //   name: "Category Level Assignee",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import("../views/pages/Dilfoods/Tickets/CateogoryAssignee/index.vue"),
  // },
  {
    path: "/stock_out_report_import",
    name: "Stock Out Import",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/Dilfoods/StockOutImport/index.vue"),
  },
  {
    path: "/model_outlet_analytics",
    name: "Model Outlet Analytics",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Analytics/model_outlet_analytics/index.vue"
      ),
  },
  // {
  //   path: "/outlet_inventory_stock",
  //   name: "Outlet Inventory Stock",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () =>
  //     import(
  //       "../views/pages/Dilfoods/Analytics/outlet_inventory_stock/index.vue"
  //     ),
  // },
  {
    path: "/warehouse_inspection_import",
    name: "Warehouse Inspection Import",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/Dilfoods/Warehouse/warehouse_inspection_import.vue"
      ),
  },
  //   {
  //     path: "/digimr/telecaller-analytics",
  //     name: "Telecaller analytics",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/digimr/analytics/main-page"),
  //   },
  //   {
  //     path: "/digimr/employee-performance",
  //     name: "Employee Performance",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/digimr/employee-performance/main-page"),
  //   },
  //   {
  //     path: "/digimr/telecaller-histories",
  //     name: "Telecaller Histories",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/digimr/Histories/main-comp"),
  //   },
  //   {
  //     path: "/digimr/best-call-status",
  //     name: "Best Call Status",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/digimr/best-call-status/main-comp"),
  //   },
  //
  // // Field Mr Routes
  //
  //   {
  //     path: "/fieldmr/referralSummary",
  //     name: "Referral Summary",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/fieldmr/main.vue"),
  //   },
  //   {
  //     path: "/fieldmr/summary",
  //     name: "Summary",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/fieldmr/analytics/main-page.vue"),
  //   },
  //   // {
  //   //   path: "/digimr/client/telecaller-histories",
  //   //   name: "Telecaller Histories",
  //   //   meta: {
  //   //     authRequired: true,
  //   //   },
  //   //   component: () => import("../views/pages/digimr/client/main-comp"),
  //   // },
  //   {
  //     path: "/users/registrations-summary",
  //     name: "User Registrations",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/live-registration/index"),
  //   },
  //   {
  //     path: "/users/registrants",
  //     name: "Registrants",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () =>
  //       import("../views/pages/live-registration/Registrants/index"),
  //   },
  //   {
  //     path: "/users/registrations-digimrvfieldmr",
  //     name: "User Registrations - DIGI MR vs Field MR",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () =>
  //       import("../views/pages/live-registration/DigiMRvFieldMR/index"),
  //   },
  //   {
  //     path: "/users/registrations-digimr",
  //     name: "User Registrations - DIGI MR",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/live-registration/DigiMR/index"),
  //   },
  //   {
  //     path: "/users/registrations-fieldmr",
  //     name: "User Registrations - Field MR",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/live-registration/FieldMR/index"),
  //   },
  //   {
  //     path: "/content_analytics/articles/overall",
  //     name: "Articles",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/articles/index"),
  //   },
  //   {
  //     path: "/content_analytics/articles/top-viewers",
  //     name: "Articles",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/articles/top-viewers/index"),
  //   },
  //   {
  //     path: "/content_analytics/live-events/summary",
  //     name: "Live Events",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/live-events/index"),
  //   },
  //   {
  //     path: "/content_analytics/live-events/registrants",
  //     name: "Live Event Registrants",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/live-events/registrants"),
  //   },
  //   {
  //     path: "/content_analytics/videos/overall",
  //     name: "Videos",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/videos/index"),
  //   },
  //   {
  //     path: "/content_analytics/newsletters/overall",
  //     name: "Newsletters",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/newsletters/index"),
  //   },
  //   {
  //     path: "/content_analytics/newsletters/top-viewers",
  //     name: "Newsletters",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/newsletters/top-viewers/index"),
  //   },
  //   {
  //     path: "/content_analytics/cases/overall",
  //     name: "Cases",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/cases/index"),
  //   },
  //   {
  //     path: "/prime_user/overall-report",
  //     name: "Prime User",
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/prime/index"),
  //   },
  //   {
  //     path: "/prime_user/view_rewards/",
  //     name: "View_Rewards",
  //     props: true,
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/prime/viewRewards"),
  //   },
  //   {
  //     path: "/forum_analytics/overall/",
  //     name: "Forum_Analytics",
  //     props: true,
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/forum/index"),
  //   },
  //   {
  //     path: "/content_analytics/retention_analysis",
  //     name: "Retention Analysis",
  //     props: true,
  //     meta: {
  //       authRequired: true,
  //     },
  //     component: () => import("../views/pages/Reports/retention"),
  //   },
  //
  //
  //
  //     // Routes Without Authentication
  //   {
  //     path: "/open_fieldmr/referralSummary",
  //     name: "Referral Summary",
  //     meta: {
  //       authRequired: false,
  //     },
  //     component: () => import("../views/pages/fieldmr/main.vue"),
  //   }
];
